import { Reducer } from 'redux';

const reducer: Reducer = state => {
  return { ...state };
};
export default reducer;
